<script setup lang="ts">
  import SearchNoResult from '@/shared/assets/images/search-no-result.svg';
  import { IconImage } from '@/shared/ui';
</script>

<template>
  <div class="flex flex-col items-center justify-center mt-6 pb-[52px]">
    <IconImage
      :src="SearchNoResult"
      alt="Nenhum resultado encontrado"
    />
    <h3 class="text-2xl font-bold leading-[30px]">
      Nenhum resultado encontrado
    </h3>
  </div>
</template>
